<template>
  <div id="game-guide">
    <div id="occupied"></div>
    <!-- 快速参赛 -->
    <div class="quick-entry-container">
      <div class="big-title">
        快速参赛
      </div>
      <p class="explain">
        报名参赛前请下载迷你世界，通过游客登录、设置密码获取迷你号
      </p>
      <div class="content">
        <div class="wrap">
          <div class="img-title">
            <img src="../assets/images/img_num1.png" />
            <span>获取迷你号</span>
          </div>
          <span style="color:#ff874b"
            >（安卓移动端官版与PC端账号互通，建议下载官版）</span
          >
          <div class="link-box">
            <div class="btn-link">
              <a :href="getType == 'iphone' ? iphoneGameLink : androidGameLink"
                ><p>下载官版</p></a
              >
            </div>
          </div>
        </div>
        <div class="wrap">
          <div class="img-title">
            <img src="../assets/images/img_num2.png" />
            <span>报名参赛</span>
          </div>
          <div class="link-box">
            <div class="btn-link">
              <p @click="toApply('/works/1')">学生个人报名</p>
            </div>
            <div class="btn-link">
              <p @click="toApply('/works/2')">院校组织报名</p>
            </div>
          </div>
        </div>
        <div class="wrap">
          <div class="img-title">
            <img src="../assets/images/img_num2.png" />
            <span>免费自学教程攻略</span>
          </div>
          <div class="link-box">
            <div
              class="btn-link"
              v-for="(btn, b) in btnArr"
              :key="b"
              @click="handleDownload(b)"
            >
              <a :href="btn.link">
                <p>
                  {{ btn.name }}
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-container">
      <div class="big-title">
        投稿步骤
      </div>
      <div class="content">
        <div class="title-one">一、获取迷你号</div>
        <div>
          <span>1、前往迷你世界官网</span
          ><a href="https://www.mini1.cn/">https://www.mini1.cn/</a
          ><span>，点击桌面版下载</span>
        </div>
        <img src="../assets/images/1.png" />
        <p>2、打开桌面版客户端文件，点击“游客登录”</p>
        <img src="../assets/images/2.png" />
        <p>3、进入游戏界面，提交信息完成实名认证</p>
        <img src="../assets/images/3.png" />
        <p>4、设置密码，并记得迷你号与密码。</p>
        <img src="../assets/images/4.png" />
        <div class="title-one">二、报名与作品投稿</div>
        <div class="title-two">（1）通道一：院校组织参赛</div>
        <div>
          <span>1、前往NCDA大赛官网院校报名页</span
          ><a href="http://www.ncda.org.cn/signup"
            >http://www.ncda.org.cn/signup</a
          ><span
            >由老师提交资料完成报名，并向大赛组委会获取“参赛院校ID”（组委会联系方式：021-51097968）</span
          >
        </div>
        <div>
          <span>2、参赛学生个人登录大赛官网：</span
          ><a href="http://www.ncda.org.cn/">http://www.ncda.org.cn/</a
          ><span>，点击作品提交按钮</span>
        </div>
        <img src="../assets/images/5.png" />
        <p>
          3、点击“注册”按钮，在以下注册页输入个人信息，参赛院校ID向负责老师获取，完成注册（填写ID后自动显示对应学校，请仔细核对学校名称）
        </p>
        <img src="../assets/images/6.png" />
        <p>4、登录后，点击“上传作品”</p>
        <img src="../assets/images/7.png" />
        <p>
          5、选择参赛类别（迷你世界游戏开发者大赛-游戏制作组/模型制作组），填写作品相关信息。请务必仔细填写，相关信息将打印在证书上，提交截止后不可修改作者及指导教师信息。
        </p>
        <img src="../assets/images/8.png" />
        <p>
          6、点击提交后，前往迷你世界游戏开发者大赛投稿页，登录迷你号，验证手机号码，选择赛事组别，选择参赛作品提交，即可完成作品投稿。
        </p>

        <div class="title-two">（2）通道二：学生个人参赛</div>
        <div>
          <span>1、前往《迷你世界全国高校游戏开发者大赛》网站</span
          ><a href="https://ncsgdc.mini1.cn/">https://ncsgdc.mini1.cn/</a
          ><span>，登录迷你号</span>
        </div>
        <img src="../assets/images/9.png" />
        <p>2、进入报名投稿页提交个人信息，即可完成报名</p>
        <img src="../assets/images/10.png" />
        <div>
          <span
            >3、报名成功后，请联系指导老师前往以下链接报名获取参赛院校ID</span
          ><a href="http://www.ncda.org.cn/signup"
            >http://www.ncda.org.cn/signup</a
          ><span>（详细步骤参考“院校组织参赛”通道）</span>
        </div>
        <p>
          4、前往作品信息页，选择赛组、选择作品、完善作品信息提交作品，即可完成投稿。
        </p>
        <img src="../assets/images/11.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { geamGuideDtat } from '../common/pageData';
export default {
  name: 'gameGuide',
  data() {
    return {
      geamGuideDtat: geamGuideDtat,
      btnArr: [
        {
          name: '游戏创作教程',
          link: 'https://www.mini1.cn/article/20200916/1446.html'
        },
        { name: '触发器教程', link: 'https://developers.mini1.cn/cfqwiki/' }
      ],
      androidBoxLink: 'https://helper.miniworldbox.com/index/apk/android',
      iphoneBoxLink:
        'https://itunes.apple.com/cn/app/%E8%BF%B7%E4%BD%A0%E7%9B%92%E5%AD%90/id1363389095?mt=8',
      iphoneGameLink:
        'https://itunes.apple.com/cn/app/%E8%BF%B7%E4%BD%A0%E4%B8%96%E7%95%8C-%E5%85%A8%E6%B0%91%E5%88%9B%E4%BD%9C%E7%9A%84%E6%B2%99%E7%9B%92%E5%B9%B3%E5%8F%B0/id1170455562?mt=8',
      androidGameLink: 'https://app.mini1.cn/export/down_app/1'
    };
  },
  computed: {
    // 判断pc|android|iphone
    getType() {
      let phoneType = '';
      let iphone = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
      if (iphone) {
        phoneType = 'iphone';
      } else {
        phoneType = 'android';
      }
      return phoneType;
    },
    isLogin() {
      if (window.sessionStorage.getItem('currentUser') != 'null') {
        this.$store.commit(
          'userStatus',
          JSON.parse(window.sessionStorage.getItem('currentUser'))
        );
      } else {
        this.$store.commit('userStatus', null);
      }
      return this.$store.getters.isLogin;
    }
  },
  mounted() {
    this.$scroll('occupied');
    window.sessionStorage.setItem(
      'pathName',
      window.location.hash.split('#')[1]
    );
  },
  methods: {
    bigImgFn(val) {
      ImagePreview({
        images: [val],
        showIndex: false
      });
    },
    handleDownload(index) {
      let v8 = '';
      switch (index) {
        case 0:
          v8 = 2;
          break;
        case 1:
          v8 = 3;
          break;
        case 4:
          v8 = 4;
          break;
        default:
          break;
      }
      this.$reportLog(16066, { v8: v8 });
    },
    toApply(path) {
      if (!this.isLogin) {
        this.$router.push(path);
      } else {
        this.isSignInfo(path);
      }
    },
    async isSignInfo(path) {
      try {
        // 查询是否有报名，在哪报的
        const res = await this.$http.apiIsSign();
        const { data } = res.data;
        if (!data) {
          this.$router.push(path);
        } else {
          let txt = data.ncda ? '院校组织' : '学生个人';
          if (
            (path == '/works/1' && data.ncda) ||
            (path == '/works/2' && !data.ncda)
          ) {
            this.$toast(`您已选择 "${txt}" 通道报名投稿`);
          } else {
            this.$router.push(path);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#game-guide {
  width: 750px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgb(53, 53, 53);
  font-size: 26px;
  .big-title {
    margin-top: 50px;
    font-size: 60px;
    font-weight: 800;
    color: rgb(53, 53, 53);
  }
  .explain {
    margin: 30px 40px;
    text-align: center;
  }
  .quick-entry-container,
  .new-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  // 快速参赛 认证开发者
  .quick-entry-container {
    .content {
      .wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img-title {
          display: flex;
          align-items: center;
          img {
            width: 55px;
            height: 25px;
            margin-right: 10px;
          }
          span {
            font-size: 30px;
            font-weight: 600;
          }
        }
        .link-box {
          display: flex;
          align-items: center;
          justify-content: space-around;
          flex-wrap: wrap;
          width: 700px;
          padding: 40px 10px;
          background: #efefef;
          margin: 20px 0 40px;
          .btn-link {
            p {
              padding: 20px 30px;
              background: #f1a269;
              border-radius: 15px;
              color: #fff;
              font-size: 28px;
              font-weight: 600;
            }
            .black {
              background: #000;
            }
            .green {
              background: #45a16e;
            }
          }
          .go-login {
            width: 250px;
            // height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            p {
              width: 100%;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .new-container {
    .content {
      padding: 0 10px;
      margin-bottom: 40px;
      .title-one {
        font-size: 30px;
        font-weight: 600;
        margin-top: 20px;
      }
      .title-two {
        font-size: 28px;
        font-weight: 600;
        margin-top: 10px;
      }
      img {
        border: 1px solid #ccc;
        margin-bottom: 15px;
      }
      span,
      p {
        font-size: 26px;
        margin-top: 5px;
      }
      a {
        color: #e96a10;
      }
    }
  }
}
</style>
